import React, {
  MutableRefObject,
  PropsWithChildren,
  createContext,
  useMemo,
} from "react";
import { Store } from "@wss/store";
import { CompareProductsState } from "./compareProductStore";

interface Props {
  compareProductsStore: Store<CompareProductsState>;
  storedFilterUrl: MutableRefObject<{ url: string; confirmed: boolean }>;
}

interface FilterModalContextType {
  compareProductsActive: boolean;
  storedFilterUrl: MutableRefObject<{ url: string; confirmed: boolean }>;
}

export const FilterModalContext = createContext<FilterModalContextType>({
  compareProductsActive: false,
  storedFilterUrl: { current: { url: "", confirmed: false } },
});

const FilterModalContextProvider = ({
  compareProductsStore,
  storedFilterUrl,
  children,
}: PropsWithChildren<Props>) => {
  const compareProductsActive = compareProductsStore.useState(
    (state) => state.active,
  );
  const contextValue = useMemo(
    () => ({
      compareProductsActive,
      storedFilterUrl,
    }),
    [compareProductsActive, storedFilterUrl],
  );

  return (
    <FilterModalContext.Provider value={contextValue}>
      {children}
    </FilterModalContext.Provider>
  );
};

export default FilterModalContextProvider;
